import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './CareerDetail.css';
import Header from '../common/header/Header' 

// This would typically come from an API or database
const getCareerById = (id) => {
  const careersData = {
    1: {
      id: 1,
      title: "Agribusiness Officer",
      company: "Farm Radio Holdings Limited (FHL)",
      location: "Lilongwe",
      type: "Full-time",
      duration: "1-year contract, renewable based on performance and availability of funds",
      applicationDeadline: "2025-10-03",
      postedDate: "2025-09-15",
      salary: "Competitive package",
      category: "Agriculture",
      reportsTo: "Farm Radio Holding Chief Executive Officer",
      
      background: "Farm Radio Holdings Limited (FHL) is a private limited company, which is a subsidiary of Farm Radio Trust (FRT), whose vision is to be a \"Leading multimedia institution providing innovative and sustainable agribusiness and development solutions in Malawi and the Sub-Saharan Africa\". Its mission is \"Building Sustainable Agri-Business and Transformative Development Services Using ICT Platforms and Approaches\". FHL is rolling out its agri business function through \"Mlimi Youth Fund\" to provide access to agricultural inputs for youth farmers, enabling them to boost production and improve livelihoods. FHL is looking for dynamic Agribusiness Officer to roll out the implementation, coordination, and sustainability of this fund.",
      
      purpose: "The Agribusiness Officer will be responsible for overseeing the planning, implementation, and monitoring of all agribusiness activities under the project. This includes managing the revolving fund system, supporting youth farmers with inputs, capacity building, and market linkage facilitation.",
      
      responsibilities: [
        {
          category: "Agribusiness Development",
          tasks: [
            "Design the sustainable youth agribusiness fund as a revolving initiative.",
            "Identify, engage, and support youth farmers and youth-led agribusinesses.",
            "Assess business viability and capacity of youth applicants for the input support.",
            "Provide technical support in farm business planning, budgeting, and enterprise development."
          ]
        },
        {
          category: "Mlimi Youth Fund Management",
          tasks: [
            "Administer the input support revolving fund in coordination with finance and procurement teams.",
            "Ensure timely distribution of inputs to eligible youth farmers.",
            "Monitor repayment schedules and ensure recovery mechanisms are adhered to.",
            "Maintain accurate records of disbursements, recoveries, and balances."
          ]
        },
        {
          category: "Capacity Building and Extension Support",
          tasks: [
            "Organize and conduct training sessions on agribusiness management, input use, good agricultural practices (GAP), and financial literacy.",
            "Work with agricultural extension agents, radio program teams, and partners to provide continuous technical support."
          ]
        },
        {
          category: "Monitoring, Evaluation, and Reporting",
          tasks: [
            "Track the performance of supported youth farmers (yields, profits, repayment, etc.).",
            "Contribute to data collection, impact stories, and periodic project reports.",
            "Provide monthly updates and quarterly progress reports to the Project Coordinator."
          ]
        },
        {
          category: "Partnerships and Market Linkages",
          tasks: [
            "Facilitate partnerships with input suppliers, buyers, processors, and financial institutions.",
            "Support youth farmers in accessing output markets for their produce."
          ]
        }
      ],
      
      qualifications: [
        "Bachelor's degree in Agribusiness, Agriculture Economics, Agronomy, or related field.",
        "At least 5-8 years of experience in agribusiness development or agricultural finance.",
        "Experience working with youth, NGOs, or donor-funded agricultural projects.",
        "Knowledge of revolving fund mechanisms and financial management principles.",
        "Strong skills in training, facilitation, and community mobilization.",
        "Proficiency in digital tools (Excel, data collection apps, etc.).",
        "Excellent communication skills, both verbal and written.",
        "Ability to work independently and as part of a team."
      ],
      
      desiredAttributes: [
        "Integrity, transparency, and accountability in managing resources.",
        "Youth-friendly and gender-sensitive approach.",
        "Knowledge of local agricultural systems and value chains."
      ],
      
      applicationProcess: "Qualified and interested individuals should submit their CV and cover letter to info@farmradiomw.org with the subject line \"Application: Agribusiness Officer\" by 3rd October 2025",
      
      // benefits: [
      //   "Competitive salary package",
      //   "Professional development opportunities",
      //   "Health insurance coverage",
      //   "Opportunity to make a meaningful impact in agricultural development",
      //   "Work with a dynamic and innovative team"
      // ]
    }
  };
  
  return careersData[id];
};

const CareerDetail = () => {
  const { id } = useParams();
  const [career, setCareer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate API call
    setTimeout(() => {
      const careerData = getCareerById(parseInt(id));
      setCareer(careerData);
      setLoading(false);
    }, 500);
  }, [id]);

  // Function to check if a job is active based on application deadline
  const isJobActive = (deadline) => {
    const today = new Date();
    const deadlineDate = new Date(deadline);
    return deadlineDate >= today;
  };

  // Function to format date
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Function to calculate days remaining
  const getDaysRemaining = (deadline) => {
    const today = new Date();
    const deadlineDate = new Date(deadline);
    const timeDiff = deadlineDate.getTime() - today.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return daysDiff;
  };

  if (loading) {
    return (
      <div className="career-detail-loading">
        <div className="loading-spinner"></div>
        <p>Loading opportunity details...</p>
      </div>
    );
  }

  if (!career) {
    return (
      <div className="career-not-found">
        <div className="container">
          <h1>Opportunity Not Found</h1>
          <p>The opportunity you're looking for doesn't exist or has been removed.</p>
          <Link to="/careers" className="btn-back">Back to Opportunities</Link>
        </div>
      </div>
    );
  }

  const active = isJobActive(career.applicationDeadline);
  const daysRemaining = getDaysRemaining(career.applicationDeadline);

  return (
    <>
    <Header/>
      <section className="career-detail-hero">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/careers">Opportunities & Careers</Link>
            <span>/</span>
            <span>{career.title}</span>
          </div>
          
          <div className="career-detail-header">
            <div className="career-detail-title-section">
              <h1>{career.title}</h1>
              <div className="career-detail-meta">
                <div className="meta-item">
                  <i className="fas fa-building"></i>
                  <span>{career.company}</span>
                </div>
                <div className="meta-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <span>{career.location}</span>
                </div>
                <div className="meta-item">
                  <i className="fas fa-clock"></i>
                  <span>{career.type}</span>
                </div>
                <div className="meta-item">
                  <i className="fas fa-calendar"></i>
                  <span>Posted: {formatDate(career.postedDate)}</span>
                </div>
              </div>
            </div>
            
            <div className="career-detail-status">
              <span className={`status-badge ${active ? 'active' : 'inactive'}`}>
                {active ? 'Active' : 'Closed'}
              </span>
              {active && daysRemaining > 0 && (
                <div className="days-remaining-large">
                  <span className="days-number">{daysRemaining}</span>
                  <span className="days-text">days left</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="career-detail-content">
        <div className="container">
          <div className="career-detail-grid">
            <div className="career-detail-main">
              {/* Background */}
              <div className="content-section">
                <h2>Background</h2>
                <p>{career.background}</p>
              </div>

              {/* Purpose */}
              <div className="content-section">
                <h2>Purpose of the Position</h2>
                <p>{career.purpose}</p>
              </div>

              {/* Key Responsibilities */}
              <div className="content-section">
                <h2>Key Responsibilities</h2>
                {career.responsibilities.map((section, index) => (
                  <div key={index} className="responsibility-section">
                    <h3>{section.category}</h3>
                    <ul>
                      {section.tasks.map((task, taskIndex) => (
                        <li key={taskIndex}>{task}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>

              {/* Qualifications */}
              <div className="content-section">
                <h2>Qualifications and Experience</h2>
                <ul className="qualifications-list">
                  {career.qualifications.map((qualification, index) => (
                    <li key={index}>{qualification}</li>
                  ))}
                </ul>
              </div>

              {/* Desired Attributes */}
              <div className="content-section">
                <h2>Desired Attributes</h2>
                <ul>
                  {career.desiredAttributes.map((attribute, index) => (
                    <li key={index}>{attribute}</li>
                  ))}
                </ul>
              </div>

              {/* Application Process */}
              <div className="content-section">
                <h2>Application Process</h2>
                <p>{career.applicationProcess}</p>
              </div>
            </div>

            {/* Sidebar */}
            <div className="career-detail-sidebar">
              <div className="sidebar-card">
                <h3>Job Summary</h3>
                <div className="job-summary">
                  <div className="summary-item">
                    <label>Position:</label>
                    <span>{career.title}</span>
                  </div>
                  <div className="summary-item">
                    <label>Location:</label>
                    <span>{career.location}</span>
                  </div>
                  <div className="summary-item">
                    <label>Type:</label>
                    <span>{career.type}</span>
                  </div>
                  <div className="summary-item">
                    <label>Duration:</label>
                    <span>{career.duration}</span>
                  </div>
                  <div className="summary-item">
                    <label>Reports to:</label>
                    <span>{career.reportsTo}</span>
                  </div>
                  <div className="summary-item">
                    <label>Salary:</label>
                    <span>{career.salary}</span>
                  </div>
                  <div className="summary-item">
                    <label>Deadline:</label>
                    <span className={!active ? 'expired' : ''}>{formatDate(career.applicationDeadline)}</span>
                  </div>
                </div>
              </div>

              {/* <div className="sidebar-card">
                <h3>Benefits</h3>
                <ul className="benefits-list">
                  {career.benefits.map((benefit, index) => (
                    <li key={index}>{benefit}</li>
                  ))}
                </ul>
              </div> */}

              <div className="sidebar-card apply-card">
                {active ? (
                  <>
                    <h3>Ready to Apply?</h3>
                    <p>Send your CV and cover letter to get started.</p>
                    <a 
                      href={`mailto:info@farmradiomw.org?subject=Application: ${career.title}`}
                      className="btn-apply-now"
                    >
                      Apply Now
                    </a>
                  </>
                ) : (
                  <>
                    <h3>Application Closed</h3>
                    <p>This opportunity is no longer accepting applications.</p>
                    <Link to="/careers" className="btn-view-other">
                      View Other Opportunities
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CareerDetail;
